export class Delivery {

    public static adapt(value: any) {
        const days = Number(value.days);
        const packages = Number(value.packages);
        const weight = Number(value.weight);
        const info = value.info
            ? String(value.info)
            : '';
        return new Delivery(
            days,
            packages,
            weight,
            info,
        );
    }

    constructor(
        public days: number,
        public packages: number,
        public weight: number,
        public info: string,
    ) { }
}
